














































































import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import teamCompletionProgress from "./teamCompletionProgress.vue";
import { Getter, Action } from "vuex-class";
import { completionChartOptions } from "../../utils";
import { Team, User, TeamCompletion } from "../../types";

@Component({
  components: {
    teamCompletionProgress
  }
})
export default class TeamCompletionBarChart extends Vue {
  @Action private fetchTeamCompletion!: (id: Number) => any;
  @Getter private currentTeamID?: number;
  @Getter private teamCompletion!: TeamCompletion;
  private completionData: any = null;
  private detailsModalShow: boolean = false;
  private selectedModalTabPosition: number = 0;
  private isShowTooltip = false;
  private tooltip =
    "The completed % is made up of users who have completed all exercises for that lesson.";

  private created() {
    if(this.teamCompletion!=null)
      this.teamCompletionData()

    this.fetchData();
  }

  @Watch("currentTeamID")
  private onCurrentTeamIdChanged(newVal: string, oldVal: string) {
    if (newVal && newVal !== oldVal) {
      this.fetchData();
    }
  }

  private fetchData() {
    this.fetchTeamCompletion(this.currentTeamID!);
  }

  openModal(selectedTab: number, completion: any) {
    if (completion.completed > 0) {
      this.detailsModalShow = true;
      this.selectedModalTabPosition = selectedTab;
    }
  }

  onModalShow() {
    document.documentElement.style.overflow = "hidden";
    var selectedElement = document.getElementById(
      this.selectedModalTabPosition.toString()
    );
    if (selectedElement != null) {
      selectedElement.scrollIntoView({ block: "center" });
    }
  }

  onModalHidden() {
    document.documentElement.style.overflow = "auto";
  }

  @Watch("teamCompletion")
  private teamCompletionData() {

    let teamCompletion: any;
    let lessons = null;
    if(this.teamCompletion!=null && this.teamCompletion.lessons!=null) 
      lessons = this.teamCompletion.lessons

    if (!this.teamCompletion.noUsersAdded || lessons == null) {
      teamCompletion = lessons;
    } else {
      teamCompletion = lessons.slice(0, 3);
    }
    this.completionData = teamCompletion;
  }
}
